import BgPattern1 from '../assets/images/bg-pattern-home-6-about-5.svg';

export function ActionSection() {
    return(
        <section className="action-section flex column align-center justify-center">
            <h2>Ready to get started?</h2>
            <button class="btn btn-contact fs18">contact us</button>
            <img src={BgPattern1} className="bg-pattern1"/>
        </section>
    )
}